export default __webpack_public_path__ + "static/media/snitches-get-stitches.ef647908.gif";